export default "__VITE_ASSET__DKlM8C9f__"